export default function React_CSSinJS() {
  return (
    <div>
      <h1>React_CSSinJS Component</h1>
      <p>This is the React_CSSinJS tutorial page.</p>
    </div>
  );
}
